import HttpV2 from './HttpV2';
import axios from 'axios';

class CampaignServiceV2 {
  static async getAdminCampaign(campaignId) {
    return HttpV2.get(`admin/campaigns/${campaignId}`);
  }

  static async getAdminAssociatedCampaigns(campaignId) {
    return HttpV2.get(`admin/campaigns/${campaignId}/associated-campaigns`);
  }

  static async getCampaignPreviews(campaignId) {
    return HttpV2.put(`admin/campaigns/${campaignId}/update-previews`);
  }

  static async adjustCampaignDates(campaignId, payload) {
    return HttpV2.patch(`admin/campaigns/${campaignId}/adjust-dates`, payload);
  }

  static async cancelCampaign(campaignId, payload) {
    return HttpV2.patch(`admin/campaigns/${campaignId}/cancel`, payload);
  }

  static async changeStatus(campaignId, payload) {
    return HttpV2.patch(`admin/campaigns/${campaignId}/change-status`, payload);
  }

  static async logSignifiCall(campaignId, payload) {
    return HttpV2.post(`admin/campaigns/${campaignId}/log-signifi`, payload);
  }

  static async downloadPdfReport(campaignId, options = {}) {
    return HttpV2.get(`campaigns/${campaignId}/pdf-report`, options);
  }

  static async checkAdminToolAccess() {
    return HttpV2.get(`admin/campaigns/admin-tool-access`);
  }

  static async getCampaignPaymentMethod(campaignId) {
    return HttpV2.get(`admin/campaigns/${campaignId}/payment-method`);
  }

  static async getCampaignAdListingDetails(campaignId) {
    return HttpV2.get(`admin/campaigns/${campaignId}/update-details`);
  }

  static async updateCampaignAdListingDetails(campaignId, payload) {
    return HttpV2.put(`admin/campaigns/${campaignId}`, payload);
  }

  static async getUploadPresignedUrl(filename) {
    return HttpV2.get(`campaigns/upload-video`, {
      params: {filename},
    });
  }

  static async registerVideo(payload) {
    return HttpV2.post(`campaigns/register-video`, payload);
  }

  static async uploadBinaryToPresignedUrl(
    presignedUrl,
    binary,
    onProgress,
    abortController
  ) {
    // Create a new axios instance for direct upload to AWS S3
    // Don't use HttpV2 as it adds headers that AWS doesn't expect
    const uploadConfig = {
      method: 'PUT',
      url: presignedUrl,
      data: binary,
      headers: {
        'Content-Type': binary.type || 'application/octet-stream',
      },
      // Increase timeout for large file uploads (10 minutes)
      timeout: 600000,
      // Track upload progress
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(percentCompleted);
      },
    };

    // For axios 0.18.0, we need to use cancelToken instead of signal
    if (abortController && abortController.signal) {
      // Create a cancel token that will be cancelled when the AbortController aborts
      const cancelToken = new axios.CancelToken((cancel) => {
        abortController.signal.addEventListener('abort', () => {
          cancel('Upload cancelled by user');
        });
      });
      uploadConfig.cancelToken = cancelToken;
    }

    const response = await axios(uploadConfig);
    return response;
  }
}

export default CampaignServiceV2;
